import { FilterArtModel, FilterFormModel, FilterOverflowModel, FilterBackwallModel } from '.';
import { formatMessage } from 'src/api';
import MESSAGES from './../../../app/Partials/Trough/TroughFilter/TroughFilter.messages';

export const filterArtData = (): FilterArtModel => ({
  exos: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.filterExosError}),
    label: formatMessage({...MESSAGES.filterExosLabel}),
    name: 'art',
    placeholder: '',
    type: 'radio',
    required: false,
    validation: 'isBoolean',
    value: 'exos',
  },
  varius: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.filterVariusError}),
    label: formatMessage({...MESSAGES.filterVariusLabel}),
    name: 'art',
    placeholder: '',
    type: 'radio',
    required: false,
    validation: 'isBoolean',
    value: 'varius',
  },
  variusMed: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.filterVariusmedError}),
    label: formatMessage({...MESSAGES.filterVariusmedLabel}),
    name: 'art',
    placeholder: '',
    type: 'radio',
    required: false,
    validation: 'isBoolean',
    value: 'variusMed',
  },
  medcare: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.filterMedcareError}),
    label: formatMessage({...MESSAGES.filterMedcareLabel}),
    name: 'art',
    placeholder: '',
    type: 'radio',
    required: false,
    validation: 'isBoolean',
    value: 'medcare',
  }
});

export const filterFormData = (): FilterFormModel => ({
  square: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.filterSquareError}),
    label: formatMessage({...MESSAGES.filterSquareLabel}),
    name: 'form',
    placeholder: '',
    type: 'checkbox',
    required: false,
    validation: 'isBoolean',
    value: 'square',
  },
  oval: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.filterOvalError}),
    label: formatMessage({...MESSAGES.filterOvalLabel}),
    name: 'form',
    placeholder: '',
    type: 'checkbox',
    required: false,
    validation: 'isBoolean',
    value: 'oval',
  },
  round: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.filterRoundError}),
    label: formatMessage({...MESSAGES.filterRoundLabel}),
    name: 'form',
    placeholder: '',
    type: 'checkbox',
    required: false,
    validation: 'isBoolean',
    value: 'round',
  }
});

export const filterOverflowData = (): FilterOverflowModel => ({
  overflowWith: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.filterWithOverflowError}),
    label: formatMessage({...MESSAGES.filterWithOverflowLabel}),
    name: 'overflow',
    placeholder: '',
    type: 'radio',
    required: false,
    validation: 'isBoolean',
    value: 'overflowWith',
  },
  overflowWithout: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.filterWithoutOverflowError}),
    label: formatMessage({...MESSAGES.filterWithoutOverflowLabel}),
    name: 'overflow',
    placeholder: '',
    type: 'radio',
    required: false,
    validation: 'isBoolean',
    value: 'overflowWithout',
  }
});


export const filterBackwallData = (): FilterBackwallModel => ({
  preparedBackWallWith: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.filterWithBackwallError}),
    label: formatMessage({...MESSAGES.filterWithBackwallLabel}),
    name: 'backwall',
    placeholder: '',
    type: 'radio',
    required: false,
    validation: 'isBoolean',
    value: 'preparedBackWallWith',
  },
  preparedBackWallWithout: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.filterWithoutBackwallError}),
    label: formatMessage({...MESSAGES.filterWithoutBackwallLabel}),
    name: 'backwall',
    placeholder: '',
    type: 'radio',
    required: false,
    validation: 'isBoolean',
    value: 'preparedBackWallWithout',
  },
});
